"use client";

import { usePathname } from "next/navigation";

interface MainContentProps {
  children: React.ReactNode;
  headerSticky?: boolean;
  isWhitelabelMode?: boolean;
}

/**
 * Client component wrapper for main content that handles
 * conditional top padding based on sticky header and current route.
 *
 * On the homepage ('/'), no top padding is applied since the homepage
 * handles its own margin/padding for transparent header state.
 * On all other pages, pt-16 is applied when the header is fixed.
 *
 * In SaaS mode, the header is always fixed.
 * In whitelabel mode, it depends on the headerSticky tenant setting.
 */
export function MainContent({ children, headerSticky, isWhitelabelMode }: MainContentProps) {
  const pathname = usePathname();
  const isHomepage = pathname === '/';

  const hasFixedHeader = isWhitelabelMode ? !!headerSticky : true;
  const paddingClass = hasFixedHeader && !isHomepage ? 'pt-16' : '';

  return (
    <main className={`flex-1 ${paddingClass}`}>
      {children}
    </main>
  );
}
